module.exports = __webpack_public_path__ + "static/media/parallax-bg-13.3ed47b87.jpg";